<mat-sidenav-container class="container" autosize>
  <mat-sidenav
    #desktopSidenav
    *ngIf="isLoggedIn"
    class="desktop-sidenav desktop-visible sidenav-scrolling side-nav-color"
    mode="side"
    position="start"
    [fixedInViewport]="true"
    [ngClass]="{
      'desktop-sidenav-minimized': desktopSideNavState === 'narrow'
    }"
    opened
  >
    <div class="small-logo" *ngIf="desktopSideNavState === 'narrow'">
      <a routerLink="/">
        <div>
          <div class="image-div">
            <img src="/assets/img/navbar-logo-icon-dark-theme.svg" />
          </div>
        </div>
      </a>
    </div>
    <a routerLink="/" *ngIf="desktopSideNavState === 'wide'">
      <img
        class="logo"
        alt="Fociva logo"
        src="/assets/img/logo-long-dark-theme.svg"
      />
    </a>
    <mat-nav-list>
      <mat-list-item *ngIf="orgLink" [routerLink]="[orgLink, 'inbox']">
        <div class="nav-link">
          <mat-icon title="Inbox" class="material-icons-outlined"
            >forum</mat-icon
          >
          <span class="nav-text">Inbox</span>
        </div>
      </mat-list-item>

      <ng-container *ngFor="let space of spaces">
        <mat-divider></mat-divider>
        <div class="space-menu-header">
          <div>
            <h4 matSubheader class="compress-subheader">{{ space.name }}</h4>
          </div>

          <button [matMenuTriggerFor]="menu" aria-label="Space menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              [routerLink]="[orgLink, 'space', space._id, 'trash']"
            >
              <mat-icon mat-list-icon title="Trash">delete</mat-icon>
              <span class="nav-text">View trashed tasks</span>
            </button>

            <button
              mat-menu-item
              (click)="this.taskService.downloadTasks({ spaceId: space._id })"
            >
              <mat-icon>download</mat-icon>
              <span>Download tasks backup file</span>
            </button>

            <button
              *ngIf="orgId"
              mat-menu-item
              (click)="
                this.taskService.importTasks({ orgId, spaceId: space._id })
              "
            >
              <mat-icon>upload</mat-icon>
              <span>Import tasks backup file</span>
            </button>
          </mat-menu>
        </div>

        <mat-list-item
          [routerLink]="[orgLink, 'space', space._id, 'current']"
          [queryParams]="{ userId }"
          [state]="{ hideFilterButtons: true }"
          class="my-current-task"
        >
          <div class="nav-link">
            <mat-icon title="{{ space.name }}" class="material-icons-outlined"
              >person_check</mat-icon
            >
            <span class="nav-text"> My current tasks</span>
          </div>
        </mat-list-item>

        <mat-list-item [routerLink]="[orgLink, 'inbox', 'space', space._id]">
          <div class="nav-link">
            <mat-icon mat-list-icon title="Backlog">tag</mat-icon>
            <span class="nav-text">Space channel</span>
          </div>
        </mat-list-item>

        <mat-list-item [routerLink]="[orgLink, 'space', space._id, 'pipeline']">
          <div class="nav-link">
            <mat-icon title="Pipeline">keyboard_double_arrow_right</mat-icon>
            <span class="nav-text">Pipeline</span>
          </div>
        </mat-list-item>

        <mat-list-item [routerLink]="[orgLink, 'space', space._id, 'backlog']">
          <div class="nav-link">
            <mat-icon mat-list-icon title="Backlog">list_alt</mat-icon>
            <span class="nav-text">Backlog</span>
          </div>
        </mat-list-item>

        <mat-list-item [routerLink]="[orgLink, 'space', space._id, 'current']">
          <div class="nav-link">
            <mat-icon mat-list-icon title="Current">directions_run</mat-icon>
            <span class="nav-text">Current</span>
          </div>
        </mat-list-item>

        <mat-list-item
          [routerLink]="[orgLink, 'space', space._id, 'completed-history']"
        >
          <div class="nav-link">
            <mat-icon
              mat-list-icon
              title="Completed"
              class="material-icons-outlined"
              >check_box</mat-icon
            >
            <span class="nav-text">Completed</span>
          </div>
        </mat-list-item>
      </ng-container>

      <ng-container *ngIf="channels.length">
        <mat-divider></mat-divider>
        <h4 matSubheader class="compress-subheader minimized-settings-header">
          Channels
        </h4>
        <ng-container *ngFor="let channel of channels">
          <mat-list-item
            [routerLink]="[orgLink, 'inbox', 'channel', channel._id]"
          >
            <div class="nav-link">
              <mat-icon mat-list-icon title="Backlog">tag</mat-icon>
              <span class="nav-text">{{ channel.title }}</span>
            </div>
          </mat-list-item>
        </ng-container>
      </ng-container>

      <mat-divider></mat-divider>
      <h4 matSubheader class="compress-subheader minimized-settings-header">
        Settings
      </h4>

      <mat-list-item
        *ngIf="trialExpiryText"
        [routerLink]="[orgLink, 'billing']"
        class="free-trial-notice"
      >
        <div class="nav-link">
          <mat-icon title="Subscribe" class="material-icons-outlined"
            >shopping_cart</mat-icon
          >
          <span class="nav-text">Free trial {{ trialExpiryText }}</span>
        </div>
      </mat-list-item>

      <mat-list-item routerLink="/settings">
        <div class="nav-link">
          <mat-icon mat-list-icon title="Settings">settings</mat-icon>
          <span class="nav-text">Settings</span>
        </div>
      </mat-list-item>

      <mat-list-item *ngIf="isSuperAdmin" routerLink="/super-admin">
        <div class="nav-link">
          <mat-icon mat-list-icon title="Admin">verified_user</mat-icon>
          <span class="nav-text">Super admin</span>
        </div>
      </mat-list-item>

      <mat-list-item *ngIf="orgLink" [routerLink]="orgLink">
        <div class="nav-link">
          <mat-icon mat-list-icon title="Organization">groups</mat-icon>
          <span class="nav-text">Organization</span>
        </div>
      </mat-list-item>

      <mat-list-item
        *ngIf="isLoggedIn"
        routerLink="/account"
        class="nav-account"
      >
        <div class="nav-account-link">
          <mat-icon mat-list-icon title="Account">account_circle</mat-icon>
          <div class="nav-account-text">
            <div>{{ loggedInOrgNameOrAccount }}</div>
            <div class="nav-account-email">{{ loggedInEmail }}</div>
          </div>
        </div>
      </mat-list-item>

      <mat-list-item *ngIf="!isLoggedIn" routerLink="/register">
        <div class="nav-link">
          <mat-icon mat-list-icon title="Register">app_registration</mat-icon>
          <span class="nav-text">Register</span>
        </div>
      </mat-list-item>

      <mat-list-item *ngIf="!isLoggedIn" routerLink="/login">
        <div class="nav-link">
          <mat-icon mat-list-icon title="Login">login</mat-icon>
          <span class="nav-text">Login</span>
        </div>
      </mat-list-item>

      <mat-list-item
        *ngIf="showDesktopSideNavToggle"
        (click)="desktopSideNavToggle()"
      >
        <div class="nav-link">
          <mat-icon
            *ngIf="desktopSideNavState === 'narrow'"
            mat-list-icon
            title="Expand Menu"
          >
            arrow_forward_ios
          </mat-icon>
          <mat-icon
            *ngIf="desktopSideNavState === 'wide'"
            mat-list-icon
            title="Collapse Menu"
          >
            arrow_back_ios
          </mat-icon>
        </div>
      </mat-list-item>
    </mat-nav-list>
  </mat-sidenav>

  <!-- MOBILE SIDE NAV MENU -->
  <mat-sidenav
    #mobileSidenav
    class="mobile-sidenav sidenav-scrolling side-nav-color"
    mode="over"
    position="end"
    [fixedInViewport]="true"
  >
    <div routerLink="/" (click)="mobileSidenav.close()">
      <img
        class="logo"
        alt="Fociva logo"
        src="/assets/img/logo-long-dark-theme.svg"
      />
    </div>

    <!-- MAKE SURE TO SET (click)="mobileSidenav.close()" if copying from links above -->
    <mat-nav-list>
      <mat-list-item *ngIf="orgLink" [routerLink]="[orgLink, 'inbox']">
        <div class="nav-link" (click)="mobileSidenav.close()">
          <mat-icon title="Inbox" class="material-icons-outlined"
            >forum</mat-icon
          >
          <span class="nav-text">Inbox</span>
        </div>
      </mat-list-item>

      <ng-container *ngFor="let space of spaces">
        <mat-divider></mat-divider>
        <div class="space-menu-header">
          <div>
            <h4 matSubheader class="compress-subheader">{{ space.name }}</h4>
          </div>

          <button [matMenuTriggerFor]="menu" aria-label="Space menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              [routerLink]="[orgLink, 'space', space._id, 'trash']"
            >
              <mat-icon mat-list-icon title="Trash">delete</mat-icon>
              <span class="nav-text">View trashed tasks</span>
            </button>

            <button
              mat-menu-item
              (click)="this.taskService.downloadTasks({ spaceId: space._id })"
            >
              <mat-icon>download</mat-icon>
              <span>Download tasks backup file</span>
            </button>

            <button
              *ngIf="orgId"
              mat-menu-item
              (click)="
                this.taskService.importTasks({ orgId, spaceId: space._id })
              "
            >
              <mat-icon>upload</mat-icon>
              <span>Import tasks backup file</span>
            </button>
          </mat-menu>
        </div>

        <mat-list-item
          [routerLink]="[orgLink, 'space', space._id, 'current']"
          [queryParams]="{ userId }"
          [state]="{ hideFilterButtons: true }"
          class="my-current-task"
        >
          <div class="nav-link" (click)="mobileSidenav.close()">
            <mat-icon title="{{ space.name }}" class="material-icons-outlined"
              >person_check</mat-icon
            >
            <span class="nav-text"> My current tasks</span>
          </div>
        </mat-list-item>

        <mat-list-item [routerLink]="[orgLink, 'inbox', 'space', space._id]">
          <div class="nav-link" (click)="mobileSidenav.close()">
            <mat-icon mat-list-icon title="Backlog">tag</mat-icon>
            <span class="nav-text">Space channel</span>
          </div>
        </mat-list-item>

        <mat-list-item [routerLink]="[orgLink, 'space', space._id, 'pipeline']">
          <div class="nav-link" (click)="mobileSidenav.close()">
            <mat-icon title="Pipeline">keyboard_double_arrow_right</mat-icon>
            <span class="nav-text">Pipeline</span>
          </div>
        </mat-list-item>

        <mat-list-item [routerLink]="[orgLink, 'space', space._id, 'backlog']">
          <div class="nav-link" (click)="mobileSidenav.close()">
            <mat-icon mat-list-icon title="Backlog">list_alt</mat-icon>
            <span class="nav-text">Backlog</span>
          </div>
        </mat-list-item>

        <mat-list-item [routerLink]="[orgLink, 'space', space._id, 'current']">
          <div class="nav-link" (click)="mobileSidenav.close()">
            <mat-icon mat-list-icon title="Current">directions_run</mat-icon>
            <span class="nav-text">Current</span>
          </div>
        </mat-list-item>

        <mat-list-item
          [routerLink]="[orgLink, 'space', space._id, 'completed-history']"
        >
          <div class="nav-link" (click)="mobileSidenav.close()">
            <mat-icon
              mat-list-icon
              title="Completed"
              class="material-icons-outlined"
              >check_box</mat-icon
            >
            <span class="nav-text">Completed</span>
          </div>
        </mat-list-item>
      </ng-container>

      <ng-container *ngIf="channels.length">
        <mat-divider></mat-divider>
        <h4 matSubheader class="compress-subheader minimized-settings-header">
          Channels
        </h4>
        <ng-container *ngFor="let channel of channels">
          <mat-list-item
            [routerLink]="[orgLink, 'inbox', 'channel', channel._id]"
          >
            <div class="nav-link" (click)="mobileSidenav.close()">
              <mat-icon mat-list-icon title="Backlog">tag</mat-icon>
              <span class="nav-text">{{ channel.title }}</span>
            </div>
          </mat-list-item>
        </ng-container>
      </ng-container>

      <mat-divider></mat-divider>
      <h4 matSubheader class="compress-subheader minimized-settings-header">
        Settings
      </h4>

      <mat-list-item
        *ngIf="trialExpiryText"
        [routerLink]="[orgLink, 'billing']"
        class="free-trial-notice"
      >
        <div class="nav-link" (click)="mobileSidenav.close()">
          <mat-icon title="Subscribe" class="material-icons-outlined"
            >shopping_cart</mat-icon
          >
          <span class="nav-text">Free trial {{ trialExpiryText }}</span>
        </div>
      </mat-list-item>

      <mat-list-item routerLink="/settings">
        <div class="nav-link" (click)="mobileSidenav.close()">
          <mat-icon mat-list-icon title="Settings">settings</mat-icon>
          <span class="nav-text">Settings</span>
        </div>
      </mat-list-item>

      <mat-list-item *ngIf="isSuperAdmin" routerLink="/super-admin">
        <div class="nav-link" (click)="mobileSidenav.close()">
          <mat-icon mat-list-icon title="Admin">verified_user</mat-icon>
          <span class="nav-text">Super admin</span>
        </div>
      </mat-list-item>

      <mat-list-item *ngIf="orgLink" [routerLink]="orgLink">
        <div class="nav-link" (click)="mobileSidenav.close()">
          <mat-icon mat-list-icon title="Organization">groups</mat-icon>
          <span class="nav-text">Organization</span>
        </div>
      </mat-list-item>

      <mat-list-item
        *ngIf="isLoggedIn"
        routerLink="/account"
        class="nav-account"
      >
        <div class="nav-account-link">
          <mat-icon mat-list-icon title="Account">account_circle</mat-icon>
          <div class="nav-account-text">
            <div>{{ loggedInOrgNameOrAccount }}</div>
            <div class="nav-account-email">{{ loggedInEmail }}</div>
          </div>
        </div>
      </mat-list-item>

      <mat-list-item *ngIf="!isLoggedIn" routerLink="/register">
        <div class="nav-link" (click)="mobileSidenav.close()">
          <mat-icon mat-list-icon title="Register">app_registration</mat-icon>
          <span class="nav-text">Register</span>
        </div>
      </mat-list-item>

      <mat-list-item *ngIf="!isLoggedIn" routerLink="/login">
        <div class="nav-link" (click)="mobileSidenav.close()">
          <mat-icon mat-list-icon title="Login">login</mat-icon>
          <span class="nav-text">Login</span>
        </div>
      </mat-list-item>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <div
      class="main-content"
      [ngClass]="{ 'compensate-for-mobile-menu': isLoggedIn }"
      #routerOutletParent
    >
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<app-bulk-action-button class="bulk-action-button-top-right">
</app-bulk-action-button>

<div *ngIf="isLoggedIn" #mobileToolbar class="mobile-visible">
  <mat-toolbar class="hidden-positioner-toolbar"> </mat-toolbar>
  <mat-toolbar color="primary" class="mobile-bottom-nav">
    <button
      *ngIf="isIosDevice"
      mat-icon-button
      (click)="mobileSidenav.close(); backNavigation()"
    >
      <div class="icon">
        <mat-icon>arrow_back</mat-icon>
      </div>
      <div class="text">Back</div>
    </button>

    <a
      class="text-decoration-none"
      routerLink="/"
      (click)="mobileSidenav.close()"
    >
      <button mat-icon-button>
        <div class="icon">
          <img
            class="mobile-nav-logo"
            src="/assets/img/navbar-logo-icon-dark-theme.svg"
          />
        </div>
      </button>
    </a>

    <a
      *ngIf="orgLink"
      [routerLink]="[orgLink, 'inbox']"
      class="text-decoration-none"
      (click)="mobileSidenav.close()"
    >
      <button mat-icon-button>
        <div class="icon">
          <mat-icon>message</mat-icon>
        </div>
        <div class="text">Inbox</div>
      </button>
    </a>

    <ng-container *ngIf="spaces.length === 1">
      <a
        *ngIf="orgLink"
        [routerLink]="[orgLink, 'space', spaces[0]._id, 'current']"
        [queryParams]="{ userId }"
        [state]="{ hideFilterButtons: true }"
        class="text-decoration-none"
        (click)="mobileSidenav.close()"
      >
        <button mat-icon-button>
          <div class="icon">
            <mat-icon class="material-icons-outlined">check_box</mat-icon>
          </div>
          <div class="text">My tasks</div>
        </button>
      </a>
    </ng-container>

    <ng-container *ngIf="spaces.length > 1 && orgLink">
      <a>
        <button mat-icon-button [matMenuTriggerFor]="spaceListMenu">
          <div class="icon">
            <mat-icon class="material-icons-outlined">check_box</mat-icon>
          </div>
          <div class="text">My tasks</div>
        </button>
      </a>

      <mat-menu #spaceListMenu="matMenu">
        <button
          *ngFor="let space of spaces"
          mat-menu-item
          [routerLink]="[orgLink, 'space', space._id, 'current']"
          [queryParams]="{ userId }"
          [state]="{ hideFilterButtons: true }"
          (click)="mobileSidenav.close()"
        >
          <mat-icon mat-list-icon class="material-icons-outlined"
            >check_box</mat-icon
          >
          <span class="nav-text">{{ space.name }}</span>
        </button>
      </mat-menu>
    </ng-container>

    <a
      *ngIf="!isLoggedIn"
      class="text-decoration-none"
      routerLink="/login"
      (click)="mobileSidenav.close()"
    >
      <button mat-icon-button>
        <div class="icon">
          <mat-icon>login</mat-icon>
        </div>
        <div class="text">Login</div>
      </button>
    </a>

    <a>
      <button mat-icon-button (click)="mobileSidenav.toggle()">
        <div class="icon">
          <mat-icon>menu</mat-icon>
        </div>
        <div class="text">Menu</div>
      </button>
    </a>
  </mat-toolbar>
</div>
